// Client V1 imports
const { track } = require('client/lib/analytics')

const DISMISS_FADE_DURATION = 300 // ms

// Action types

const TOOLTIP_ADD = 'TOOLTIP_ADD'
const TOOLTIP_DISMISS = 'TOOLTIP_DISMISS'
const TOOLTIP_REMOVE = 'TOOLTIP_REMOVE'

// Action creators

function showTooltip(options) {
  return async function (dispatch) {
    // Add the tooltip to the container
    dispatch({
      type: TOOLTIP_ADD,
      payload: options
    })
    // Send a tracking call
    await track('tooltip-show', {
      'tooltip_key': options.key
    })
  }
}

function removeTooltip(key) {
  return {
    type: TOOLTIP_REMOVE,
    payload: { key }
  }
}

// Action dispatchers

function dismissTooltip(key) {
  return async function (dispatch, getState) {
    // Fade the tooltip out
    dispatch({
      type: TOOLTIP_DISMISS,
      payload: { key }
    })
    // Tell the tooltip that it has been dismissed
    const { tooltips } = getState()
    const tooltipItem = tooltips.getItem(key)
    if (tooltipItem && tooltipItem.onDismiss) {
      tooltipItem.onDismiss()
    }
    // Remove the tooltip after the fade-out
    setTimeout(() => {
      dispatch(removeTooltip(key))
    }, DISMISS_FADE_DURATION)
    // Send a tracking call
    await track('tooltip-dismiss', {
      'tooltip_key': key
    })
  }
}

module.exports = {
  // Action types
  TOOLTIP_ADD,
  TOOLTIP_DISMISS,
  TOOLTIP_REMOVE,
  // Action creators
  showTooltip,
  removeTooltip,
  // Action dispatchers
  dismissTooltip
}
